import { makeActionCreator } from '../../config/store/utils';
import { getNotificationReport } from '../../services/notifications';
import { batch } from 'react-redux';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const formatDateForBackend = (date) => {
  return format(date, 'yyyy-MM-dd'); // Formats date as YYYY-MM-DD
};

// Define the target timezone
const LOCAL_TIMEZONE = 'America/Santiago';

export const GET_NOTIFICATION = 'GET_NOTIFICATION';
export const GET_NOTIFICATION_ERROR = 'GET_NOTIFICATION_ERROR';
export const GET_NOTIFICATION_SUCCESS = 'GET_NOTIFICATION_SUCCESS';

export const onGetNotification = makeActionCreator(GET_NOTIFICATION);
export const onGetNotificationError = makeActionCreator(GET_NOTIFICATION_ERROR, 'payload');
export const onGetNotificationSuccess = makeActionCreator(GET_NOTIFICATION_SUCCESS, 'payload');

export const onGetNotificationThunk = (date, currTurn) => async (dispatch, getState) => {
  dispatch(onGetNotification());

  try {
    const formattedDate = formatDateForBackend(date[0]);
    const { data: response } = await getNotificationReport({
      date: formattedDate,
      currTurn,
    });

    // Convert speed_transgressions timestamps from UTC to local timezone
    const velocity = response.speed_transgressions
      ? response.speed_transgressions.map((item) => {
          // Ensure timestamp is treated as UTC by appending 'Z'
          const utcDate = new Date(item.timestamp + 'Z');
          
          // Convert UTC to local time in 'America/Santiago'
          const localTime = formatInTimeZone(utcDate, LOCAL_TIMEZONE, "yyyy-MM-dd HH:mm:ss");

          return {
            ...item,
            timestamp: localTime,  // Store the converted local timestamp
          };
        })
      : [];

    // Other notification categories without timezone conversion
    const flat = response.punctures || [];
    const adas = response.adas || [];
    const fatigue = response.fatigue || [];
    const yawn = response.yawn || [];
    const idle = response.ralenti || [];

    // Add `allId` to each row, starting from 0
    let counter = 0;
    const addAllId = (rows) =>
      rows.map((row) => ({
        ...row,
        allId: counter++, // Add a unique identifier and increment the counter
      }));

    const all = [
      ...addAllId(velocity),
      ...addAllId(flat),
      ...addAllId(adas),
      ...addAllId(fatigue),
      ...addAllId(yawn),
      ...addAllId(idle),
    ];

    return batch(() => {
      dispatch(
        onGetNotificationSuccess({
          all,
          velocity,
          flat,
          adas,
          fatigue,
          yawn,
          idle,
        })
      );
    });
  } catch (error) {
    console.error("Error fetching notifications:", error);
    return batch(() => {
      dispatch(onGetNotificationError({ error }));
    });
  }
};
